// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { updateCustomField } from 'utils/proposals'
import reject from 'lodash/reject'
import union from 'lodash/union'
import some from 'lodash/some'
import { arrayMove } from 'react-sortable-hoc'

// Atoms
import TextInput from 'atoms/TextInput'
import Spacer from 'atoms/Spacer'
import ItemsGrid from 'atoms/ItemsGrid'
import Chip from 'atoms/Chip'
import FieldLayout from '../FieldLayout'
import FieldOptionInput from '../FieldOptionInput'

export default class ChoiceEditor extends Component {
  static propTypes = {
    field: PropTypes.object.isRequired,
    normalizedFields: PropTypes.array.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  updateField = (fieldData) => {
    const { field, normalizedFields, onProposalUpdate } = this.props
    onProposalUpdate({
      data: {
        fields: updateCustomField(normalizedFields, field.key, fieldData)
      }
    })
  }

  handleLabelSave = (label) => {
    this.updateField({ label })
  }

  handleOptionAdd = (label) => {
    const { field } = this.props
    const alreadyExists = some(field.options, { label })
    if (!alreadyExists) {
      const options = union(field.options, [{ label }])
      this.updateField({ options })
    }
  }

  handleOptionsSortEnd = ({ oldIndex, newIndex }) => {
    const { field } = this.props
    const options = arrayMove(field.options, oldIndex, newIndex)
    this.updateField({ options })
  }

  handleOptionDelete = option => () => {
    const { field } = this.props
    const options = reject(field.options, { label: option.label })
    this.updateField({ options })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete()
  }

  renderOptions() {
    const { field } = this.props
    return !!field.options && !!field.options.length && (
      <Fragment>
        <Spacer small />
        <ItemsGrid spacing={16} onSortEnd={this.handleOptionsSortEnd}>
          { field.options.map(option => (
            <Chip
              clickable={false}
              key={option.label}
              onDelete={this.handleOptionDelete(option)}
            >
              { option.label }
            </Chip>
          )) }
        </ItemsGrid>
      </Fragment>
    )
  }

  render() {
    const { field } = this.props
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Multiple choice" onDelete={this.handleDelete}>
          <TextInput
            required
            maxLength={50}
            multiline
            label="Label"
            placeholder="Type your question here..."
            defaultValue={field.label || ''}
            onSave={this.handleLabelSave}
          />
          <Spacer small />
          <FieldOptionInput
            onOptionAdd={this.handleOptionAdd}
            placeholder="Add as many options as you’d like..."
          />
          { this.renderOptions() }
        </FieldLayout>
      </Fragment>
    )
  }
}
